import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import Cookies from 'js-cookie';

const setDefaultLocale = () => {
    let cookieLocale = Cookies.get("origamCurrentLocale");
    if(!cookieLocale) {
      let defaultLang = 'de-CH';
      let userLang = navigator.language || navigator.userLanguage; 
      userLang = userLang.toLowerCase().substring(0, 2);
      if(userLang==='de') defaultLang = 'de-CH';
      else if(userLang==='en') defaultLang = 'en-US';
      else if(userLang==='fr') defaultLang = 'fr-CH';
      else if(userLang==='it') defaultLang = 'it-IT';
      else if(userLang==='cs') defaultLang = 'cs-CZ';
      const cookieValue = `c=${defaultLang}|uic=${defaultLang}`;
      Cookies.set("origamCurrentLocale", cookieValue, { expires: 365, path: '/' });
      Cookies.set("origamLanguage", defaultLang, { expires: 365, path: '/' });
    } 
}
setDefaultLocale();

const getOrigamLanguage = () => {
    var cookie = Cookies.get('origamCurrentLocale');
    if (cookie) {
        let lang = cookie.split('|')[0];
        lang = lang.split('c=')[1];
        if (lang && lang.length > 0 && lang.includes('-')) {
            return lang.split('-')[0];
        }
    }
    return false;
}

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        //debug: true,
        react: {
            useSuspense: false,
        },
        lng: getOrigamLanguage() || 'de',
        fallbackLng: 'de',
        whitelist: ['de', 'en', 'fr', 'it', 'cs'],

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        backend: {
            loadPath: process.env.PUBLIC_URL + '/locales/{{lng}}/{{ns}}.json',
        },
    });

export default i18n;